import {NgModule,} from '@angular/core';

// Imports Angular modules
import {CommonModule,} from '@angular/common';
import {FormsModule, ReactiveFormsModule,} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HttpClientModule} from "@angular/common/http";

// Imports Covalent modules
import {
  CovalentLayoutModule, CovalentMessageModule, CovalentMenuModule,
  CovalentMediaModule, CovalentLoadingModule, CovalentDataTableModule,
  CovalentStepsModule, CovalentDialogsModule,CovalentExpansionPanelModule,
  CovalentSearchModule, CovalentPagingModule
} from '@covalent/core';

// Imports Angular Materials modules
import {
  MatButtonModule, MatCardModule, MatIconModule,
  MatListModule, MatMenuModule, MatTooltipModule,
  MatSlideToggleModule, MatInputModule, MatCheckboxModule,
  MatToolbarModule, MatSnackBarModule, MatSidenavModule,
  MatTabsModule, MatSelectModule, MatGridListModule, MatDialogModule,
  MatDatepickerModule,MatNativeDateModule
} from '@angular/material';

const ANGULAR_MODULES:any[] = [
  CommonModule, FormsModule, ReactiveFormsModule,
  BrowserModule, BrowserAnimationsModule, HttpClientModule
];

const MATERIAL_MODULES:any[] = [
  MatButtonModule, MatCardModule, MatIconModule,
  MatListModule, MatMenuModule, MatTooltipModule,
  MatSlideToggleModule, MatInputModule, MatCheckboxModule,
  MatToolbarModule, MatSnackBarModule, MatSidenavModule,
  MatTabsModule, MatSelectModule, MatGridListModule, MatDialogModule,
  MatDatepickerModule,MatNativeDateModule
];

const COVALENT_MODULES:any[] = [
  CovalentLayoutModule, CovalentMessageModule, CovalentMenuModule,
  CovalentMediaModule, CovalentLoadingModule, CovalentDataTableModule,
  CovalentStepsModule, CovalentDialogsModule,CovalentExpansionPanelModule,
  CovalentSearchModule, CovalentPagingModule
];

@NgModule({
  imports: [
    ANGULAR_MODULES,
    MATERIAL_MODULES,
    COVALENT_MODULES,
  ],
  declarations: [],
  exports: [
    ANGULAR_MODULES,
    MATERIAL_MODULES,
    COVALENT_MODULES,
  ]
})
export class SharedModule {
}
